"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNamedSettingsMenu = void 0;
const react_1 = require("react");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const table_context_1 = require("../table-context");
const named_settings_context_1 = require("../../../common/settings/named/named-settings-context");
function useNamedSettingsMenu(tag) {
    const { getNamedSettings, saveNamedSettings, deleteNamedSettings, } = react_1.useContext(named_settings_context_1.NamedSettingsContext);
    const { filtersState, setFiltersState, columnsState, setColumnsState, sorts, setSorts, } = react_1.useContext(table_context_1.TableContext);
    const [opened, setOpened] = react_1.useState(false);
    const [savedItems, setSavedItems] = react_1.useState([]);
    const [selectedItem, setSelectedItem] = react_1.useState(null);
    const confirmDeleteDialog = react_1.useRef(null);
    const createDialog = react_1.useRef(null);
    const selectSaved = event_callback_hook_1.useEventCallback((settings) => {
        setSelectedItem(settings.id);
        const parsed = JSON.parse(settings.settings);
        if (parsed.filtersState != null) {
            setFiltersState(parsed.filtersState);
        }
        if (parsed.columnsState != null) {
            setColumnsState(parsed.columnsState);
        }
        if (parsed.sorts != null) {
            setSorts(parsed.sorts);
        }
    });
    const load = react_1.useCallback(async () => {
        const settings = await getNamedSettings(tag);
        setSavedItems(settings);
    }, [getNamedSettings, tag]);
    const createSaved = event_callback_hook_1.useEventCallback(async (settings) => {
        const parsed = {
            filtersState,
            columnsState,
            sorts,
        };
        settings.settings = JSON.stringify(parsed);
        settings.tag = tag;
        settings = await saveNamedSettings(settings);
        setSelectedItem(settings.id);
        await load();
    });
    const deleteSaved = event_callback_hook_1.useEventCallback(async (id) => {
        await deleteNamedSettings(id);
        setSelectedItem(null);
        await load();
    });
    const openMenu = react_1.useCallback(() => {
        setOpened(true);
    }, []);
    const closeMenu = react_1.useCallback(() => {
        setOpened(false);
    }, []);
    react_1.useEffect(() => {
        load();
    }, [load]);
    return {
        opened,
        openMenu,
        closeMenu,
        savedItems,
        selectSaved,
        createSaved,
        deleteSaved,
        selectedItem,
        confirmDeleteDialog,
        createDialog,
    };
}
exports.useNamedSettingsMenu = useNamedSettingsMenu;
//# sourceMappingURL=named-settings-hook.js.map